module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Medium.08e5566.ttf";